<!-- 成本调整操作 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <!-- <purchaseGoodsTemplate  @selectDataAction="selectDataAction" ref="purchaseGoodsTemplate"></purchaseGoodsTemplate> -->
      <div v-if="isLoaded">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <!-- 主要信息 -->
                     <div v-if="scope.index == 0">
                        <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                           <el-row ref="mainForm" v-if="dataActionBox.actionType != 2&&dataActionBox.actionType != 3">
                              <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField"
                                            :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                 <el-input class="form_codition" v-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                           :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, true)" :disabled="formOneValue.isChange == 0 ||
                          dataActionBox.actionType == 2
                          || formOneValue.isUpdate == 0
                          ">
                                    <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, true)" slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0 ||
                            dataActionBox.actionType == 2
                            ">
                                    </el-button>
                                 </el-input>
                                 <df-date class="form_codition" v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" :isShowLong="false" />
                                 <el-input class="form_codition" v-else-if="formOneValue.entityField == 'ccmApply'" clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                           v-model.trim="sendDataInfo.ccmApplyName"></el-input>
                                 <el-input class="form_codition" v-else-if="formOneValue.entityField == 'ccmDep'" clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                           v-model.trim="sendDataInfo.ccmDepName"></el-input>
                                 <el-input class="form_codition" v-else-if="formOneValue.entityField == 'ccmRemark'" clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" type="textarea"
                                           v-model.trim="sendDataInfo[formOneValue.entityField]">
                                 </el-input>
                                 <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                                               :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" @change="$forceUpdate()"
                                               v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                       <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                       </el-option>
                                    </el-select>
                                 <el-input class="form_codition" v-else clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                              </el-form-item>
                           </el-row>
                           <el-row ref="mainForm" v-if="dataActionBox.actionType == 2||dataActionBox.actionType == 3">
                              <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                 <span v-if="formOneValue.isRift == 1">
                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                          sendDataInfo[formOneValue.entityField] }}</a>
                                 </span>
                                 <span v-else-if="formOneValue.fieldType == 'date'">
                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                       {{
                            $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                          }}
                                    </span>
                                 </span>
                                 <span v-else-if="formOneValue.entityField == 'salesId'">{{ sendDataInfo.salesName }}</span>
                                 <span v-else-if="formOneValue.entityField == 'opmId'">{{ sendDataInfo.opmName }}</span>
                                 <span v-else-if="formOneValue.entityField == 'depId'">{{ sendDataInfo.depName }}</span>
                                 <span v-else-if="formOneValue.entityField == 'isWms'">{{ sendDataInfo[formOneValue.entityField]
                        == 0 ? '否' : '是' }}</span>
                        <span v-else-if="formOneValue.fieldType == 'formatter'">{{
                                       getValue(sendDataInfo[formOneValue.entityField],
                                          formOneValue.entityField, formOneValue.fieldType,
                                          formOneValue.formatterContent) }}</span>
                                 <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                              </el-form-item>
                           </el-row>
                        </el-form>
                        <!-- 明细信息 -->
                        <div>
                           <el-form :inline="true" size="mini">
                              <div v-if="dataActionBox.actionType != 2&&dataActionBox.actionType != 3" id="operateBtn">
                                 <el-button type="primary" size="mini" @click="addDetails()">新增
                                 </el-button>
                                 <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                 </el-button>
                                 <el-button @click="exportTemplate" size="mini" type="primary">下载模版</el-button>
                                 <el-button @click="importDetails" size="mini" type="primary">导入明细</el-button>
                              </div>
                              <el-table size="mini" ref="mxTableRef" class="baseTable" :data="sendDataInfo.costChangedetailList" :row-class-name="tableRowClassName" border style="width: 100%" :height="mxHeight">
                                 <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2&&dataActionBox.actionType != 3">
                                    <template slot-scope="scope">
                                       <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                                  v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                    <template slot-scope="scope">
                                       <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2&& dataActionBox.actionType != 3"
                                                 @keyup.native.enter="openSearch(formOneValue.searchId, scope.$index, 'bgmName', 'bgmName')"
                                                 v-model="sendDataInfo.costChangedetailList[scope.$index][formOneValue.entityField]">
                                          <el-button @click="openSearch(formOneValue.searchId, scope.$index, 'bgmName', 'bgmName')" slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0 ||
                                dataActionBox.actionType == 2
                                ">
                                          </el-button>
                                       </el-input>

                                       <!-- 新成本价-->
                                       <el-input @blur="blur(scope.$index, formOneValue.entityField)" :ref="formOneValue.entityField" @input="calculatePrice(1, scope.$index)"
                                                 v-else-if="formOneValue.entityField == 'newPrice' && dataActionBox.actionType != 2&& dataActionBox.actionType != 3" :maxlength="$store.state.inputLength" type="number"
                                                 min="0" v-model.number="sendDataInfo.costChangedetailList[scope.$index][formOneValue.entityField]">
                                       </el-input>
                                       <!-- 变更数量-->
                                       <el-input @blur="blur(scope.$index, formOneValue.entityField)" :ref="formOneValue.entityField" @input="calculatePrice(1, scope.$index)"
                                                 v-else-if="formOneValue.entityField == 'changeNum' && dataActionBox.actionType != 2&& dataActionBox.actionType != 3" :maxlength="$store.state.inputLength" type="number"
                                                 min="0" v-model.number="sendDataInfo.costChangedetailList[scope.$index][formOneValue.entityField]">
                                       </el-input>
                                       <!-- 新含税价-->
                                       <el-input @blur="blur(scope.$index, formOneValue.entityField)" :ref="formOneValue.entityField" @input="calculatePrice(2, scope.$index)"
                                                 v-else-if="formOneValue.entityField == 'newPsprice' && dataActionBox.actionType != 2&& dataActionBox.actionType != 3" :maxlength="$store.state.inputLength" type="number"
                                                 min="0" v-model="sendDataInfo.costChangedetailList[scope.$index][formOneValue.entityField]">
                                       </el-input>
                                       <span v-else-if="formOneValue.fieldType == 'date'">
                                          <span v-if="sendDataInfo.costChangedetailList[scope.$index][formOneValue.entityField]">
                                             {{ $common.getLocalTime(sendDataInfo.costChangedetailList[scope.$index][formOneValue.entityField]) }}
                                          </span>
                                       </span>
                                       <span v-else-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(sendDataInfo.costChangedetailList[scope.$index][formOneValue.riftField])">
                                             {{ sendDataInfo.costChangedetailList[scope.$index][formOneValue.entityField] }}</a>
                                       </span>
                                       <span v-else>{{ sendDataInfo.costChangedetailList[scope.$index][formOneValue.entityField]
                          }}</span>
                                    </template>
                                 </el-table-column>
                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <div class="foot1">
               <div class="sureButton">
                  <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印</el-button>
                  <el-button v-if="dataActionBox.actionType != 2&& dataActionBox.actionType != 3" type="primary" @click="initActionBox('sendDataInfo', 'pisOrderAuxinf')">取消</el-button>
                  <el-button v-if=" dataActionBox.actionType == 3" type="primary" @click="initActionBox()">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo', 'pisOrderAuxinf')" v-if="dataActionBox.actionType == 0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo', 'pisOrderAuxinf')" v-if="dataActionBox.actionType == 1">保存</el-button>
               </div>
               <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
                  <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                     <span class="number" type="success">{{ sendDataInfo[itemV.entityField] }}</span>
                  </el-form-item>
               </el-form>
            </div>
         </div>
      </div>

      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="70%" top="20px" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog title="导入" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
         <initDataUpload :url="url" :errorUrl="'costChange/exportChangeFail'" :listShow="true" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
         </initDataUpload>
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
export default {
   name: "costAdAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      ExtractionScheme,
   },
   data() {
      //这里存放数据
      return {
         mxHeight: 0,
         guaranteeBeginDay: "",
         detailRules: false, //规则
         ruleDisabled: false,
         selectDataTable: false,
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         detaislDataInfo: {},
         selectedDataIndex: 0,
         value1: "",
         sendDataInfo: {
            "applyTime": '',
            "ccmApply": '',
            "ccmDep": '',
            "ccmRemark": "",
            ccmApplyName: '', // 申请人
            ccmDepName: '', // 部门
            "costChangedetailList": [
            ]
         },
         showTabs: "",
         formDataList: [],
         tabForm: [],
         mxForm: [],
         footForm: [],
         dictionariesData: {},
         userOneList: [],
         goodsList: [],
         storageRoomList: [],
         salesmanList: [],
         editDateilsIndex: "",
         exId: "",
         seId: "",
         ceshi: "",
         dialogTitle: "",
         seWidth: "",
         height: "",
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         DialogVisible: false,
         DialogExtract: false,
         newFormDataList: [],
         seType: "",
         smId: "",
         parentSearchData: {
            smId: "",
         },
         isLoaded: false,
         orderId: "",
         printsouce: "",
         seIndex: 0,  //选中索引
         isBuyer: 0,
         flag: false,
         importShow: false,
         importType: "",
         url: "",
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.costChangedetailList": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.totalNumber = 0
            this.sendDataInfo.totalOldmoney = 0//总原含税成本金额
            this.sendDataInfo.totalNewmoney = 0//总新含税成本金额
            this.sendDataInfo.totalCount = newValue.length
            this.sendDataInfo.totalDiffmoney = 0
            newValue.forEach((item, keys) => {
               this.sendDataInfo.totalNumber = this.sendDataInfo.totalNumber + (item.num || 0)
               this.sendDataInfo.totalOldmoney = this.$common.getDecimalInfo(3, this.sendDataInfo.totalOldmoney + item.oldPsmoney)
               this.sendDataInfo.totalNewmoney = this.$common.getDecimalInfo(3, this.sendDataInfo.totalNewmoney + item.newPsmoney)
               this.sendDataInfo.totalDiffmoney = this.$common.getDecimalInfo(3, this.sendDataInfo.totalDiffmoney + item.diffMoney)
               this.$set(this.sendDataInfo.costChangedetailList[keys], 'newPrice', this.$common.updataNum('newPrice', item).newPrice)
               this.$set(this.sendDataInfo.costChangedetailList[keys], 'changeNum', this.$common.updataNum('changeNum', item).changeNum)
               this.$set(this.sendDataInfo.costChangedetailList[keys], 'newPsprice', this.$common.updataNum('newPsprice', item).newPsprice)
            })
         },
         deep: true,
      }
   },
   //方法集合
   methods: {
      getValue(val, type, fieldType, arr) {
         var str = ""
         if (type == 'smIntype') {
            this.dictionariesDatas.forEach(item => {
               if (item.diValue === val) {
                  str = item.diName
               }
            })
         } else if (fieldType == 'formatter') {
            if (arr) {
               JSON.parse(arr).forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value === val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key === val) {
                     str = item.value
                  }
               })
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      // 主表单select框切换enter切换焦点事件方法
      selectChange(e) {
         if (e == false) {
            for (let index = 0; index < this.inputel.length; index++) {
               if (this.inputel[index] == document.activeElement) {
                  this.nextFocus(index);
                  break;
               }
            }
         }
      },
      // 触发组件的提交
      fileSuccess(val) {
      },
      // 关闭弹窗
      closeExcel(val) {
         this.importShow = false
         if (val.list.length > 0) {
            // 清理空数据
            this.sendDataInfo.costChangedetailList = this.sendDataInfo.costChangedetailList.filter(item =>
               item.bgmId !== "" && item.bgmName !== "");
            // 处理新数据并设置默认值
            const processedItems = val.list.map(item => ({
               ...item,
               changeNum: item.changeNum,
               newPrice: item.newPrice || 0,
               newPsprice: item.newPsprice || 0
            }));

            // 过滤重复项
            const existingBgmIds = new Set(this.sendDataInfo.costChangedetailList.map(item => item.bgmId));
            const uniqueNewItems = processedItems.filter(item => !existingBgmIds.has(item.bgmId));

            // 添加到列表
            this.sendDataInfo.costChangedetailList.push(...uniqueNewItems);
            this.sendDataInfo.costChangedetailList.push(...list)
         }
      },
      exportTemplate() {
         window.location.href = `${window.global_config.BASE_URL}/costChange/downChangeDetailExcel`
      },
      importDetails() {
         this.$refs['sendDataInfo'].validate((valid) => {
            if (valid) {
               this.importShow = true,
               this.url = `costChange/exportChangeDetail`
               this.importType = 'exportChangeDetail'
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "warning",
               });
            }
         });
      },
      blur(index, entityField) {
         this.sendDataInfo.costChangedetailList[index][entityField] = this.$common.getDecimalInfo(2, this.sendDataInfo.costChangedetailList[index][entityField])
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            console.log(this.actionData);
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      toDetail(orderId) {
         this.$parent.$parent.$parent.toDetail(orderId);
      },
      //换行提示
      lineMessageBox(data) {
         let txtArr = data.message.split("<br/>");
         let newArr = [];
         const h = this.$createElement;
         for (const i in txtArr) {
            newArr.push(h("p", null, txtArr[i]));
         }
         this.$alert(h("div", null, newArr), "提示", {
            confirmButtonText: "确定",
            callback: (action) => { },
         });
      },

      //提取返回
      changeInputModel(val) {
         this.DialogVisible = false;
         if (val != "" && val != undefined) {
            console.log(val)
            if (this.flag) {
               if (this.seType == 'coName') {
                  this.sendDataInfo['coName'] = val['coName']
                  this.sendDataInfo['coId'] = val['coId']
               } else {
                  for (let key in val) {
                     this.sendDataInfo[key] = val[key]
                  }
               }
            } else {
               if (Array.isArray(val)) {
                  // 清理空数据
                  this.sendDataInfo.costChangedetailList = this.sendDataInfo.costChangedetailList.filter(item =>
                     item.bgmId !== "" && item.bgmName !== "");

                  // 处理新数据并设置默认值
                  const processedItems = val.map(item => ({
                     ...item,
                     changeNum: item.num,
                     newPrice: item.newPrice || 0,
                     newPsprice: item.newPsprice || 0
                  }));

                  // 过滤重复项
                  const existingBgmIds = new Set(this.sendDataInfo.costChangedetailList.map(item => item.bgmId));
                  const uniqueNewItems = processedItems.filter(item => !existingBgmIds.has(item.bgmId));

                  // 添加到列表
                  this.sendDataInfo.costChangedetailList.push(...uniqueNewItems);
               } else if (typeof val === 'object' && val !== null) {
                  for (let key in val) {
                     this.sendDataInfo.costChangedetailList[this.seIndex][key] = val[key]
                  }
                  this.sendDataInfo.costChangedetailList[this.seIndex]['changeNum'] = val['num']
               }

            }

         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, field, flag = false) {
         if (type == "salesId") {
            if (this.parentSearchData.smId == "") {
               return this.$message({
                  message: "请先选择购进单位",
                  type: "warning",
               });
            }
         }
         this.flag = flag
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         if (field == 'bgmName') {
            this.parentSearchData.coId = this.sendDataInfo.coId
            this.parentSearchData[field] = this.sendDataInfo.costChangedetailList[this.seIndex][field]
            return
         }
         this.parentSearchData[field] = this.sendDataInfo[field]
      },
      tableRowClassName({ row, rowIndex }) {
         row.index = rowIndex;
      },
      addDetails() {
         this.$refs["sendDataInfo"].validate((valid) => {
            if (valid) {
               var flag = false
               if (this.sendDataInfo.costChangedetailList.length > 0) {
                  this.sendDataInfo.costChangedetailList.forEach(item => {
                     if (item.bgmId == "") {
                        flag = true
                        this.$nextTick(() => {
                           this.selectedDetailsIndex = Number(
                              this.sendDataInfo.costChangedetailList.length - 1
                           );
                           this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                           let refsElTable = this.$refs.mxTableRef;
                           refsElTable.clearSelection();
                           refsElTable.toggleRowSelection(
                              this.sendDataInfo.costChangedetailList[this.selectedDetailsIndex]
                           );
                        });
                     }
                  })
               }
               if (flag) {
                  return
               }
               this.sendDataInfo.costChangedetailList.push({})
               var index = this.sendDataInfo.costChangedetailList.length - 1
               for (const key in this.detaislDataInfo) {
                  this.$set(this.sendDataInfo.costChangedetailList[index], key, this.detaislDataInfo[key])
               }
               this.$nextTick(() => {
                  this.selectedDetailsIndex = Number(
                     this.sendDataInfo.costChangedetailList.length - 1
                  );
                  this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.costChangedetailList[this.selectedDetailsIndex]
                  );
               });
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               flag = true;
               return false;
            }
         });
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
               this.$refs["bgmName"][index + 1].focus();
               this.selectedDetailsIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                  );
               });
               return;
            }
            this.addDetails("sendDataInfo");
            return;
         }
         this.$refs[field][index].focus();
      },
      detailsAction(cate = 0) {
         if (cate == 0) {
            this.editDateilsIndex = "";
            return false;
         }

         var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo));
         if (dataInfo.psodPacknum <= 0) {
            this.$message({
               message: "请填写采购数量",
               type: "error",
            });
            return false;
         }
         if (this.editDateilsIndex !== "") {
            this.sendDataInfo.costChangedetailList.splice(this.editDateilsIndex, 1);
         }
         this.sendDataInfo.costChangedetailList.push(dataInfo);
         this.editDateilsIndex = "";
      },
      // 计算价格
      calculatePrice(cate, index, flag) {
         var info = this.sendDataInfo.costChangedetailList[index];
         if (info.changeNum > info.num) {
            this.sendDataInfo.costChangedetailList[index].changeNum = info.num
            if (!flag) {
               this.calculatePrice(cate, index, true)
            }
            this.$message.error("变更数量不能大于数量")
            return
         }
         switch (cate) {
            case 1: // 单价计算
               // 通过数量计算
               // 计算含税价格 单价+单价*税率/100
               var thisPrice = NP.plus(
                  info.newPrice, //成本价
                  NP.divide(NP.times(info.newPrice, info.inRate), 100)
               );
               // 新含税成本价
               this.sendDataInfo.costChangedetailList[index].newPsprice =
                  this.$common.getDecimalInfo(2, thisPrice);
               // 计算金额 单价*数量
               // 新成本金额
               this.sendDataInfo.costChangedetailList[index].newMoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(info.newPrice, info.changeNum)
                  );
               // 计算新含税金额 含税价格*数量
               this.sendDataInfo.costChangedetailList[index].newPsmoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(thisPrice, info.changeNum)
                  );
               this.sendDataInfo.costChangedetailList[index].diffPrice = this.$common.getDecimalInfo(2, NP.minus(this.sendDataInfo.costChangedetailList[index].newPsprice, info.oldPsprice));
               this.sendDataInfo.costChangedetailList[index].diffMoney = this.$common.getDecimalInfo(2, NP.minus(this.sendDataInfo.costChangedetailList[index].newPsmoney, info.oldPsmoney));
               break;
            case 2: // 含税价格计算
               // 计算单价 含税价格/(税率/100+1)
               var thisPrice = NP.divide(
                  info.newPsprice,
                  NP.plus(NP.divide(info.inRate, 100), 1)
               );
               this.sendDataInfo.costChangedetailList[index].newPrice =
                  this.$common.getDecimalInfo(2, thisPrice);
               // 计算金额 单价*数量
               this.sendDataInfo.costChangedetailList[index].newMoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(thisPrice, info.changeNum)
                  );
               // 计算含税金额 含税价格*数量
               this.sendDataInfo.costChangedetailList[index].newPsmoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(info.newPsprice, info.changeNum)
                  );
               this.sendDataInfo.costChangedetailList[index].diffPrice = this.$common.getDecimalInfo(2, NP.minus(info.newPsprice, info.oldPsprice));
               this.sendDataInfo.costChangedetailList[index].diffMoney = this.$common.getDecimalInfo(2, NP.minus(this.sendDataInfo.costChangedetailList[index].newPsmoney, info.oldPsmoney));

               break;
            default:
               break;
         }
      },
      initActionBox(sendDataInfo) {
         if (this.dataActionBox.actionType == 3) {
            this.$emit("drawerCancel", 0);
            // this.$parent.getDataList()
            this.init();
            return
         }
         var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
         this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel", 0);
               // this.$parent.getDataList()
               this.init();
               this.$refs[sendDataInfo].resetFields();
            })
            .catch(() => { });
      },
      init() {
         for (let key in this.sendDataInfo) {
            if (key == "pisOrderAuxinf") {
               for (let sonOne in this.sendDataInfo[key]) {
                  this.sendDataInfo[key][sonOne] = "";
               }
            } else {
               this.sendDataInfo[key] = "";
            }
         }
         this.sendDataInfo.costChangedetailList = [];
         this.sendDataInfo.isWms = 0;
         this.sendDataInfo.totalMoney = 0;
         this.sendDataInfo.totalNumber = 0;
         this.sendDataInfo.totalCount = 0;
      },

      // 选择采购员
      selectUserOne(data) {
         data.forEach((item) => {
            if (item.opmId == this.sendDataInfo.opmId) {
               this.sendDataInfo.psomBusdept = item.depId;
            }
         });
      },
      async isShowData(name, value) {
         switch (name) {
            case "supplier":
               var dataInfo = sessionStorage.getItem("selectSupplierData");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.sendDataInfo.smId = dataInfo.smId;
                  this.sendDataInfo.smName = dataInfo.smName;
               }
               this.sendDataInfo.salesId = "";
               this.getUnitSalesmanList();
               break;
            case "cargoOwner":
               var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.sendDataInfo.pisOrderAuxinf.coId = dataInfo.coId;
                  this.sendDataInfo.pisOrderAuxinf.coName = dataInfo.coName;
               }
               break;
         }
      },

      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.filterMainField()
         this.init();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            this.parentSearchData.smId = "";
            this.getUnitSalesmanList();
            this.sendDataInfo.applyTime = new Date().getTime()
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
            this.smId = dataInfo.smId;
            this.getUnitSalesmanList();
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
            }, 16.7)
         })

      },
      //确认新增
      sendDataAction(formName1, formName2) {
         let flag = false;
         this.$refs[formName1].validate((valid) => {
            if (valid) {
               this.sub();
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               flag = true;
               return false;
            }
         });
      },
      async sub() {
         if (this.sendDataInfo.costChangedetailList.length < 1) {
            this.$message({
               message: "请添加明细",
               type: "error",
            });
            return;
         } else if (
            this.sendDataInfo.costChangedetailList.some(
               (val) =>
                  val.newPrice === ""
            )
         ) {
            this.$message({
               type: "error",
               message: "新成本价不能空",
            });
            return;
         }
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.addCostChange(this.sendDataInfo);
         } else {
            var responseData = await this.$http.updateCostChange(this.sendDataInfo);
         }
         if (responseData.status == 200) {
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit("drawerCancel", 1);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      deleteDetails() {
         if (this.sendDataInfo.costChangedetailList.length < 1) {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
            return false;
         }
         this.sendDataInfo.costChangedetailList.splice(this.selectedDataIndex, 1);
         this.selectedDataIndex = 0;
      },
      // 复制
      copyDetails() {
         if (this.sendDataInfo.costChangedetailList.length < 1) {
            return this.$message({
               message: "暂无可复制明细",
               type: "warning",
            });
            return false;
         } else {
            this.sendDataInfo.costChangedetailList.push(
               JSON.parse(JSON.stringify(this.sendDataInfo.costChangedetailList[this.selectedDataIndex]))
            );
         }
      },
      // 获取业务员
      async getUnitSalesmanList() {
         this.salesmanList = [];
         let responseData = await this.$http.getUnitSalesmanList({
            ids: [this.sendDataInfo.smId],
         });
         if (responseData.status == 200) {
            this.salesmanList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      // 获取供货员
      async getSpecialUser() {
         let responseData = await this.$http.getSpecialUser({ opmBuyer: 1 });
         if (responseData.status == 200) {
            this.userOneList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      // 获取字典数据
      async getPartDictionariesData() {
         let responseData = await this.$http.getPartDictionariesData({
            ids: [20, 21],
         });
         if (responseData.status == 200) {
            this.dictionariesData = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      // 获取所有可用库房列表
      async getAllStorageRoom() {
         let responseData = await this.$http.getAllStorageRoom();
         if (responseData.status == 200) {
            this.storageRoomList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 判断是不是采购员
      checkIsBuyer() {
         let info = JSON.parse(sessionStorage.getItem('userInfo'))
         this.sendDataInfo.ccmApplyName = info.opmName
         this.sendDataInfo.ccmApply = info.opmId
         this.sendDataInfo.ccmDepName = info.depName
         this.sendDataInfo.ccmDep = info.depId
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
               this.mxForm.forEach(item1 => {
                  if (item1.fieldType == 'number') {
                     this.$set(this.detaislDataInfo, item1.entityField, 0)
                  } else if (item1.fieldType == 'search' && item1.setField) {
                     var arr = item1.setField.split(',')
                     arr.forEach(item2 => {
                        this.$set(this.detaislDataInfo, item2, "")
                     })
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "")
                  }
               })
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].isShowForm = 0
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
                  .jurconfigform[index])
            }
         })
         var arr = [{ entityField: "costChangedetailList" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.showTabs = this.tabForm[0].jciName;
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox();
         this.checkIsBuyer()
         this.isLoaded = true;
      });
      this.getSpecialUser();
      this.getUnitSalesmanList();
      this.getPartDictionariesData();
      this.getAllStorageRoom();
      this.$dbCache.Record_Get(4).then((res) => {
         //明细拦截
         let obj = res
         if (obj && obj.isEnable == 1) this.detailRules = true;
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}

.v-modal {
   position: static !important;
   width: 100%;
   height: 100%;
   background: transparent;
}
.sureButton {
   position: absolute;
   left: 50%;
   transform: translateX(-50%);
}
.foot1 {
   display: flex;
   /* justify-content: center; */
   align-items: center;
   width: 100%;
   background: #fff;
   height: 46px;
   padding: 5px 10px;
   z-index: 999;
   position: fixed;
   bottom: 0;
   left: 0;
   box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
.number {
   color: red;
   font-size: 18px !important;
   background: none;
   border: none;
}
</style>
